The type of event, i.e. `PositionProfileClosed`.
